import React from 'react';
import { FloatingTabStyled, CloseIcon } from './floatingTab.styled';
import Box from '../Box';

interface TabProps {
  value?: string;
  active?: boolean;
  closable?: boolean;
  onClick?: (event: React.MouseEvent<HTMLElement>, value: string) => void;
  onClose?: (value: string) => void;
  children?: React.ReactNode | React.ReactNode[];
}

const FloatingTab = ({
  value,
  active,
  closable,
  onClick,
  onClose,
  children,
}: TabProps) => {
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    onClick(event, value);
  };

  const handleIconClick = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();

    onClose(value);
  };

  return (
    <FloatingTabStyled active={active} onClick={handleClick}>
      {children}
      {closable ? (
        <Box ml={2} sx={{ display: 'inline-flex' }}>
          <CloseIcon
            name='close'
            size='xsmall'
            onClick={handleIconClick}
            color='grey'
            active={active}
          />
        </Box>
      ) : null}
    </FloatingTabStyled>
  );
};

export default FloatingTab;
